import React from 'react';
import Link from 'next/link';
import { Dropdown } from 'react-bootstrap';
import { useRouter } from 'next/router';
import CustomToggle from '../../CustomToggle';
import { useUserProfile } from '../../../hooks/useUserProfile';

interface UserProfileMenuProps {
  // Any future props can be added here
}

const UserProfileMenu: React.FC<UserProfileMenuProps> = () => {
  const router = useRouter();
  const { user, loading, getUserDisplayName, handleLogout } = useUserProfile();

  if (loading) {
    return null; // Or a loading spinner if preferred
  }

  if (!user) {
    return (
      <div className="d-flex gap-3">
        <Link href="/auth/sign-in" className="btn btn-link">
          Sign In
        </Link>
        <Link href="/auth/sign-up" className="btn btn-primary mv-2">
          Enroll
        </Link>
      </div>
    );
  }

  return (
    <Dropdown>
      <Dropdown.Toggle as={CustomToggle} id="dropdownMenuButton1">
        <i className="fa fa-user" aria-hidden="true"></i>
        <span className="ms-1 d-none d-lg-inline-block">
          {getUserDisplayName()}
        </span>
      </Dropdown.Toggle>
      <Dropdown.Menu
        align="end"
        popperConfig={{
          strategy: 'fixed',
          modifiers: [
            {
              name: 'offset',
              options: {
                offset: [0, 8],
              },
            },
            {
              name: 'preventOverflow',
              options: {
                padding: 16, // Add padding to prevent menu from touching viewport edge
              },
            },
          ],
        }}
      >
        <Dropdown.Item as={Link} href="/profile">
          <i className="fa fa-tachometer-alt me-2"></i>Dashboard
        </Dropdown.Item>
        <Dropdown.Item as={Link} href="/profile?tab=personal-info">
          <i className="fa fa-user me-2"></i>Edit Profile
        </Dropdown.Item>
        {/* <Dropdown.Item as={Link} href="/profile?tab=fitness">
          <i className="fa fa-heart me-2"></i>Fitness Preferences
        </Dropdown.Item> */}
        <Dropdown.Item as={Link} href="/library">
          <i className="fa fa-book me-2"></i>My Library
        </Dropdown.Item>
        <Dropdown.Item as={Link} href="/library?tab=history">
          <i className="fa fa-history me-2"></i>Watch History
        </Dropdown.Item>
        <Dropdown.Item as={Link} href="/profile?tab=subscription">
          <i className="fa fa-credit-card me-2"></i>Subscription
        </Dropdown.Item>
        <Dropdown.Item as={Link} href="/profile?tab=account">
          <i className="fa fa-cog me-2"></i>Account Settings
        </Dropdown.Item>
        <Dropdown.Divider />
        <Dropdown.Item onClick={handleLogout}>
          <i className="fa fa-sign-out me-2"></i>Sign Out
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default UserProfileMenu;
